import type { UseIconsProps } from 'composables/useIcons';
import type { PropDoc } from 'shared/elements-definition';
import type { Colors, Sizes } from 'types';
import { useIconsPropsDocs } from 'composables/useIcons';

export type HeadingLevels = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span';

export interface HeadingProps extends UseIconsProps {
  /**
   * What this component should be rendered as
   * If you dont want to pollute you heading. Use `span`
   * @defaultValue 'h2'
   */
  as?: HeadingLevels | null;
  title?: string;
  color?: Colors;
  size?: Sizes | '2xl';
}

type HeadingPropKeys = keyof HeadingProps;

/**
 * API docs mapping for `<e-heading>` props.
 *
 * Keys come from {@link HeadingProps}, values are used by the docs renderer
 * to build the props table.
 */
export const headingPropsDocs: Record<HeadingPropKeys, PropDoc> = {
  ...useIconsPropsDocs,
  as: {
    name: 'as',
    type: 'HeadingLevels | null',
    descriptionKey: 'heading.as.description'
  },
  title: {
    name: 'title',
    type: 'string',
    descriptionKey: 'heading.title.description'
  },
  color: {
    name: 'color',
    type: `'primary' | 'secondary' | 'accent' | 'error' | 'warning' | 'info' | 'success' | 'neutral' | 'mono'`,
    descriptionKey: 'heading.color.description'
  },
  size: {
    name: 'size',
    type: `'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'`,
    descriptionKey: 'heading.size.description'
  }
} as const;
